export default __webpack_public_path__ + "static/media/O-043.5f9bf8e7.png";